import MeetingMessageStore from './schema/MeetingMessageStore';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';

const defaultMeetingMessageStore: MeetingMessageStore = {
    metrics: {
        keyToSessionStartMap: new ObservableMap<string, number>({}),
    },
};

export const getStore = createStore<MeetingMessageStore>(
    'meetingMessageStore',
    defaultMeetingMessageStore
);
export default getStore();
